import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the model to confirm. */
const modelToDeleteSignal = createSignal<number | null>(null);

export const setModelToDelete = (modelId: number | null): void => {
	modelToDeleteSignal.value = modelId;
};

export default modelToDeleteSignal;
